import { observer } from 'mobx-react-lite'
import { Button, Typography } from 'shared/ui'
import { ProgressBar } from 'shared/ui/ProgressBar'
import { useRcsWizardContext } from 'pages/settings/pages/rcsV2/context/rcsWizardContext'
import { RcsBadge } from 'pages/settings/pages/rcsV2/ui'

import styles from './styles.module.scss'

export const RcsContinueSetup = observer(() => {
  const { lastStep, navigationStore, openStartOverConfirm } = useRcsWizardContext()

  const continueStep = navigationStore.getStepForContinue(lastStep)
  const stepNumber = navigationStore.getStepNumber(continueStep)
  const totalSteps = navigationStore.allStepsLength

  const onContinue = () => navigationStore.goToStep(continueStep)

  return (
    <section className={styles.continue}>
      <RcsBadge />
      <Typography variant='heading-md' className={styles.title} ariaLabel='RcsContinueSetup_title'>
        Continue your setup
      </Typography>
      <ProgressBar
        percent={(stepNumber / totalSteps) * 100}
        withAllBorders
        withBg
        className={styles.progressBar}
      />
      <Typography
        variant='body-lg-regular'
        color='var(--content-primary-tertiary)'
        className={styles.supportingText}
        ariaLabel='RcsContinueSetup_supportingText'
      >
        You left off at Step {stepNumber} of {totalSteps} in RCS setup. Pick up where you stopped or
        start fresh.
      </Typography>
      <div className={styles.actions}>
        <Button
          onClick={onContinue}
          text={
            <>
              Continue:&nbsp;
              <span className={styles.stepHint}>
                Step {stepNumber}/{totalSteps}
              </span>
            </>
          }
        />
        <Button text='Start over' contained='secondary' onClick={openStartOverConfirm} />
      </div>
    </section>
  )
})
